import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "g-home g-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "g-image-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block g-image-wall" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sm:hidden g-image-wall-mobile" })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["content"]
const _hoisted_6 = ["content"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "description",
  content: "規格說明"
}, null, -1)
const _hoisted_8 = ["content"]
const _hoisted_9 = ["content"]
const _hoisted_10 = {
  itemprop: "offers",
  itemscope: "",
  itemtype: "http://schema.org/Offer"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("link", {
  itemprop: "availability",
  href: "http://schema.org/InStock"
}, null, -1)
const _hoisted_12 = ["content"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "priceCurrency",
  content: "TWD"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperProducImage = _resolveComponent("SwiperProducImage")!
  const _component_ImageList = _resolveComponent("ImageList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SwiperProducImage, {
      recommendedGroups: _ctx.recommendedGroups,
      onGoProductDetail: _ctx.goProductDetail,
      onGoProductList: _ctx.goProductList
    }, null, 8, ["recommendedGroups", "onGoProductDetail", "onGoProductList"]),
    _createVNode(_component_ImageList, {
      class: "",
      title: '發燒新品',
      subTitle: 'New Arrival',
      is: _ctx.imageList,
      imageList: _ctx.imageList,
      onGoProductDetail: _ctx.goProductDetail
    }, null, 8, ["is", "imageList", "onGoProductDetail"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.imageList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (image) => {
            return (_openBlock(), _createElementBlock("div", {
              key: image.CmdyId,
              itemscope: "",
              itemtype: "http://schema.org/Product"
            }, [
              _createElementVNode("meta", {
                itemprop: "name",
                content: image.CmdyName
              }, null, 8, _hoisted_5),
              _createElementVNode("meta", {
                itemprop: "productID",
                content: image.CmdyId
              }, null, 8, _hoisted_6),
              _hoisted_7,
              _createElementVNode("meta", {
                itemprop: "url",
                content: `https://horlay.com/productDetail/` + image.CmdyId
              }, null, 8, _hoisted_8),
              _createElementVNode("meta", {
                itemprop: "image",
                content: image.Image.PcWeb
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("meta", {
                  itemprop: "price",
                  content: image.MinPriceReal
                }, null, 8, _hoisted_12),
                _hoisted_13
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}